var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DataTable',{ref:"unapproved",attrs:{"url":_vm.api.ACTIONS.PASSENGERS,"perPage":'100',"enable-add":false,"enable-edit":false,"enable-delete":false,"formatter":_vm.formatter,"actions-extra-main":_vm.actions,"fields-hidden-main":[
    'gender',
    'whatsapp_number',
    'updated_at',
    'rejected_count',
    'account_id',
    'email',
    'profile_image',
    'wallet',
    'active',
    'deleted_at',
    'birthday',
    'id_card',
    'billing_email',
    'phone_number',
  ],"titles":_vm.titles}})
}
var staticRenderFns = []

export { render, staticRenderFns }